<template lang="pug">
  .main
    Hero(:content="heroContent")
    .container
      .rows.filter
        .col.filter-item(v-for="(tab, key) in menuData", :class="{ 'is-active': key === currentArea }", @click="setArea(key)") {{ tab }}
      ClassCard(v-for="(data, key) in getCurrentClasses()", :classContent="data", :key="key", v-scroll-reveal={origin: 'right'})
</template>

<script>
import Memu from '@/../static/json/menu.json'
import Datas from '@/../static/json/class.json'

import Hero from '@/components/Hero'
import ClassCard from '@/components/ClassCard'

export default {
  components: {
    Hero,
    ClassCard
  },
  data () {
    return {
      heroContent: {
        title: '偏鄉教室。',
        imageNo: 6
      },
      currentArea: 'siemreap-w',
      menuData: Memu.class,
      classData: Datas
    }
  },
  methods: {
    setArea (area) {
      this.currentArea = area
    },
    getCurrentClasses () {
      return this.classData.filter(s => s.area === this.currentArea)
    }
  }
}
</script>

<style lang="sass" scoped>
.filter
  margin: 100px 0 40px
  &-item
    +fs($fz: 22px, $fw: 700, $ta: center, $lh: 1.5)
    cursor: pointer
    padding: 10px 0
    &.is-active
      +fs($c: $c-primary)
    &.is-active,
    &:hover
      +pos($p: relative)
      &::before
        +fs($fz: 48px, $fw: 900)
        +pos($p: absolute, $t: -64px, $l: calc(50% - 16px))
        font-family: "Font Awesome 5 Free"
        display: block
        content: '\f3c5'
    +rwd(xs)
      +fs($fz: 16px)
    +rwd(mbl)
      +fs($fz: 18px)
</style>



// WEBPACK FOOTER //
// src/views/Classes.vue